import gql from 'graphql-tag';

export const UPDATECERTIFIED = gql`
mutation  updateCertified($input: updationIscertified){
  updateCertified(input:$input)
}
`;
